import { useMemo } from 'react';
import { collectNodesAndDescendantIds } from 'state/product-description/helper';
import type { ProductNode } from 'state/product-description/model';

import { useCountPatchedFields } from './useCountPatchedFields';

type FieldsNodes = ReadonlyArray<ProductNode> | undefined;

/** Mirrors {@link useCurrentBlockInvalidFields}: toggle-gated modified count for a block's children. */
export function useCurrentBlockModifiedCount(children: FieldsNodes): number {
  const fieldIds = useMemo(() => Array.from(new Set(collectNodesAndDescendantIds(children))), [children]);
  return useCountPatchedFields([fieldIds])[0];
}
